import { Component, OnInit } from '@angular/core';
import { UserGroupService } from '../services/user-group.service';
import { InvitationService } from '../services/invitation.service';
import { Invitation } from '../models/invitation';
import { ActivatedRoute } from '@angular/router';
import { User } from '../models/group';
import { GroupService } from '../services/group.service';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  groups: any[];
  invitations: Invitation[];
  currentUser: User;

  constructor(
    private route: ActivatedRoute,
    private userGroupService: UserGroupService,
    private groupService: GroupService,
    private invitationService: InvitationService) { }

  ngOnInit() {
    this.currentUser = this.route.snapshot.data.currentUser;
    this.getInvitedGroups();
    this.getJoinedGroups();
  }

  getInvitedGroups(): any {
    this.invitationService.getInvitationsByEmail(this.currentUser.email).snapshotChanges().subscribe(res => {
      this.invitations = [];
      res.forEach(r => {
        var val = r.payload.val();
        val['id'] = r.key;
        this.invitations.push(new Invitation(val));
      });
    });
  }

  acceptInvitation(invitation: Invitation) {
    this.invitationService.accept(invitation.id);
  }

  private getJoinedGroups() {
    this.userGroupService.getGroups().valueChanges().subscribe(grpRes => {
      if (grpRes) {
        this.groups = [];
        var ids = Object.keys(grpRes);
        ids.forEach(id => {
          this.groupService.getById(id).query.once('value').then(groupRes => {
            if (groupRes) {
              var res = groupRes.val();
              res['key'] = id;
              this.groups.push(res);
            }
          })
        })
      }
    })
  }
}
